import React from "react";
import {Row, Col, Input, Select, Form, DatePicker} from 'antd';


import {useSelector, useDispatch } from 'react-redux';
import { atualizaProduto} from '../../store/cadastro-produto.reducer';
import { InputNumero } from "../../../../Numeros/input-numero";

const TabEstoqueComercial = ({dataTab, innerTabLevel1})=> {

    // const {atualizaProduto} = getActions() 
    const {produto} = useSelector(state => state.produto);
    const dispatch = useDispatch()

    const changeUNComHandler = (evt)=> {
        dispatch(atualizaProduto( Object.assign({}, produto, {uCom: evt.target.value})));
    }

    let estoqueInicial = [
                            <Col span={6}>
                                <Form.Item label="Estoque Inicial" name="valorEstoqueInicial">
                                    <InputNumero data-tab={dataTab} data-innerTabLevel1={innerTabLevel1} />
                                </Form.Item>
                            </Col>,
                            <Col span={6}>
                                <Form.Item label="Validade Para Estoque Inicial" name="validadeEstoqueInicial">
                                    <DatePicker data-tab={dataTab} data-innerTabLevel1={innerTabLevel1} style={{width: "100%"}} format={"DD/MM/YYYY"}/>
                                </Form.Item>
                            </Col>,
                            <Col span={6}>
                                <Form.Item label="Lote para o Estoque Inicial" name="loteEstoqueInicial">
                                    <Input data-tab={dataTab} data-innerTabLevel1={innerTabLevel1} />
                                </Form.Item>
                            </Col>
    ]

    if(produto.id || produto.importadoNFe){
        estoqueInicial = "";
    }
     

    return (
        <Row gutter={[16, 16]}>
           
           {estoqueInicial}

            <Col span={6}> 
                <Form.Item label="Unidade Comercial" name="uCom" onBlur={changeUNComHandler}>
                    <Input data-tab={dataTab} data-innerTabLevel1={innerTabLevel1} />
                </Form.Item>
            </Col>
            <Col span={6}>
                <Form.Item label="Quantidade Mínima" name="estoqueMinimo">
                    <InputNumero data-tab={dataTab} data-innerTabLevel1={innerTabLevel1} />
                </Form.Item>
            </Col>
            
            <Col span={6}>
                <Form.Item label="EAN Comercial" name="eanCom">
                    <Input data-tab={dataTab} data-innerTabLevel1={innerTabLevel1} />
                </Form.Item>
            </Col>
            
            
            
        </Row>
    );
}

export {TabEstoqueComercial};